import { TDescriptionValue } from 'shared/types/typographyComponents';

export const LIST: TDescriptionValue[][] = [
  [
    { value: 'Циан.Помощник', isBold: true },
    {
      value:
        ' — чат на базе искусственного интеллекта (ИИ), который персонализирует поиск жилья: понимает запросы, формирует подборки и отвечает на типовые вопросы. Пользователи получают быстрые ответы, а служба поддержки справляется с большим потоком сообщений без расширения штата',
    },
  ],
  [
    { value: 'ЦианGPT', isBold: true },
    {
      value:
        ' — технология генеративного создания описаний объявлений. Она учитывает характеристики объекта и инфраструктуру, обеспечивает единообразие и качество карточек, помогает пользователям быстрее выходить на рынок и улучшает конверсию',
    },
  ],
];
